// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1exVL","right":"styles_right__2xW1s"};